import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Box from "src/components/Default/Main/Box";

import { NewButton } from "../../../Default/LekUI/Button";

export const DefaultPicker = ({ boxes, Header, emptyText }) => {
	const { t } = useTranslation();

	const renderBoxes = () => {
		if (boxes.length === 0) {
			return <p>{emptyText}</p>;
		}

		return boxes.map(
			(
				{
					key,
					title,
					subtitle,
					path,
					submitText,
					Icon,
					isNew,
					variant,
					onClick,
					testId,
				},
				i,
			) => {
				const buttonProps = onClick
					? { onClick }
					: { component: Link, to: path };
				return (
					<div key={key || title} className="content-picker-item">
						<div className="gap-8 flex flex-col">
							<div className="flex items-center justify-start ml--4">
								<Icon className="icon-big icon-black" />
								<span className="size-20 ml-4">{title}</span>
								{isNew && (
									<div className="success-box w-fit-content py-4 px-6 border-radius-8 size-12 ml-8">
										{t("commands.news")}
									</div>
								)}
							</div>
							<div className="size-16-light text-grey m-0">{subtitle}</div>
						</div>
						<NewButton
							variant={(variant ?? i % 2 === 0) ? "primary" : "outlined"}
							{...buttonProps}
							data-test-id={testId || `picker-item-${i}`}
						>
							{submitText}
						</NewButton>
					</div>
				);
			},
		);
	};
	return (
		<Box Header={Header} className="content-picker-container">
			<div className="content-picker">{renderBoxes()}</div>
		</Box>
	);
};
